import { HeroSection } from "@/components/sections/HeroSection";
// import { StatsSection } from "@/components/sections/StatsSection";
import { OperationsDashboard } from "@/components/sections/OperationsDashboard";
import { StepsSection } from "@/components/sections/StepsSection";
import { VaultSection } from "@/components/sections/VaultSection";
import { FeaturedCats } from "@/components/sections/FeaturedCats";
import { ContractAddressesSection } from "@/components/sections/ContractAddressesSection";

export default function HomePage() {
  return (
    <>
      <HeroSection />
      {/* <StatsSection /> */}
      <OperationsDashboard />
      <StepsSection />
      <VaultSection />
      <FeaturedCats />
      <ContractAddressesSection />
    </>
  );
}
